<template>
  <header @mouseleave="leave" :class="{'headerColor': headerColor}">
    <div class="header">
      <transition name="vides">
        <div class="head-video" @click="videoshow = false" v-if="videoshow">
          <div class="video">
            <video id="video" @click="videoshow = true" controls="controls" loop="loop" autoplay="autoplay" src="../../assets/video/x.mp4"></video>
          </div>
        </div>
      </transition>
      <div class="logo" @click="to">
        <img src="../../assets/images/LOGO.png" alt="">
      </div>
      <div class="menu-control" @click="slidershow = true">
        <div class="menu-con" :class="{'menu-hover': slidershow}"></div>
      </div>
      <nav>
        <div class="nav">
          <ul>
            <li v-for="(li, index) in mainl">
              <router-link :to="navTo(index)">
                <p @mouseenter="enter(index)">{{li.name}}</p>
              </router-link>
            </li>
          </ul>
        </div>
      </nav>
      <div class="header-right">
        <ul>
          <div class="rkbox" @mouseover="choose_show = true" @mouseleave="choose_show = false">
            <div class="had">
              <span class="enter">员工入口</span>
              <img class="rkjt" src="../../assets/images/rkjt.png" alt="">
            </div>
            <div class="choose-box" v-if="choose_show">
              <a href="https://www.ixcloud.com.cn/" target="_blank" rel="noneferrer">亿信云平台</a>
              <a href="http://crm.ztys.com.cn/" target="_blank" rel="noneferrer">客户关系管理</a>
              <a href="http://mail.ztys.com.cn/" target="_blank" rel="noneferrer">电子邮件系统</a>
			  <a href="http://www.eztys.com/" target="_blank" rel="noneferrer">中天亿信装备制造</a>
            </div>
          </div>
          <li @mouseenter="iphoneshow = true" @mouseleave="iphoneshow = false">
            <div class="li-img">
              <img src="../../assets/images/phone_03.png" alt="">
              <img src="../../assets/images/phone_03_a.png" alt="">
            </div>
            <div class="iphone" v-if="iphoneshow">400 657 0281</div>
          </li>
          <li @mouseenter="qqshow = true" @mouseleave="qqshow = false">
            <div class="li-img">
              <img src="../../assets/images/qq.png" alt="">
              <img src="../../assets/images/qq_a.png" alt="">
            </div>
            <div class="qq" v-if="qqshow">
              <p>492566</p>
            </div>
          </li>
          <li @mouseenter="wxshow = true" @mouseleave="wxshow = false">
            <div class="li-img">
              <img src="../../assets/images/wx.png" alt="">
              <img src="../../assets/images/wx_a.png" alt="">
            </div>
            <div class="wx" v-if="wxshow">
            </div>
          </li>
          <!-- <li>
            <img src="../../assets/images/lang.png" alt="">
            <img src="../../assets/images/lang_a.png" alt="">
          </li> -->
        </ul>
      </div>
    </div>
    <!-- 侧栏 -->
    <div class="slide-menu" :class="{'slide-show': slidershow}">
      <transition name="slide_menu">
        <div class="slide-span" v-if="slidershow" @click="slidershow = false"></div>
      </transition>
      <div class="slide-main">
        <div>
          <router-link :to="{name: 'index'}">
            <h3>首页</h3>
          </router-link>
        </div>
        <div class="sub-slide">
          <h3><router-link :to="{path: '/about.html'}"><span>关于我们</span></router-link><span class="plus" @click.stop="slide1">+</span></h3>
          <ul v-if="slid1">
            <li v-for="(item, index) in main0">
              <router-link :to="slideTo(index)">
                <span>{{item.title}}</span>
              </router-link>
            </li>
          </ul>
        </div>
        <div class="sub-slide">
          <h3><router-link :to="{path: '/products.html'}"><span>产品服务</span></router-link><span class="plus" @click.stop="slide2">+</span></h3>
          <ul v-if="slid2">
            <router-link :to="{path: '/develop.html'}">
              <li><span>互联网定制服务</span></li>
            </router-link>
            <router-link :to="{path: '/bigdata.html'}">
              <li><span>大数据应用服务</span></li>
            </router-link>
            <router-link :to="{path: '/city.html'}">
              <li><span>智慧城市</span></li>
            </router-link>
          </ul>
        </div>
        <div class="sub-slide">
          <h3><router-link :to="{path: '/application.html'}"><span>行业应用</span></router-link><span class="plus" @click.stop="slide3">+</span></h3>
          <ul v-if="slid3">
            <li v-for="(item, index) in sms">
              <router-link :to="{name: 'article', params: {
                id: item.id + '.html',
                ch: 31
              }}">
                <span>{{item.title}}</span>
              </router-link>
            </li>
          </ul>
        </div>
        <div class="sub-slide">
          <router-link :to="{path: '/news.html'}">
            <h3>新闻中心</h3>
          </router-link>
        </div>
        <div class="sub-slide">
          <router-link :to="{path: '/support.html'}">
            <h3>在线支持</h3>
          </router-link>
        </div>
      </div>
    </div>
    <div class="header-content" @mouseleave="leave">
      <div class="span" v-if="show"></div>
      <transition name="fade">
        <div class="content" v-show="cont[0]">
          <div class="content-main">
            <div class="submain">
              <div class="href" v-for="(item, index) in main0" :key="index">
                <router-link :to="slideTo(index)">
                  <h3><img :src="item.img" alt=""><span>{{item.title}}</span></h3>
                  <p>{{item.description}}</p>
                </router-link>
              </div>
            </div>
            <div @click="showVideo" class="con-right">
              <div class="r-img">
                <img src="../../assets/images/video.png" alt="">
              </div>
              <div class="con-r-message">
                <p class="con-r-msg">我们致力于通过现代用户体验和持续创新帮助您取得成功</p>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div class="content1" v-show="cont[1]">
          <div class="content-main">
            <div class="submain1">
              <div class="subm">
                <router-link :to="{path: '/develop.html'}">
                  <div class="subm-head">
                    <img src="../../assets/images/server1.png" alt="">
                    <span>互联网定制开发</span>
                  </div>
                </router-link>
                <div class="subm-msg">
                  <p>18年行业沉淀，始终把友好的用户体验、高质量的代码作为基本要求，紧随时代步伐，把握前沿技术，以适应互联网的更新迭代。</p>
                </div>
                <div class="subm-con">
                  <div class="submc" v-for="(item, index) in subms[0].name" :key="index">
                    <router-link :to="{name: 'article', params: {
                      id: id1[index] + '.html',
                      ch: 32
                    }}">
                      <span>{{item}}</span>
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="subm">
                <router-link :to="{path: '/bigdata.html'}">
                  <div class="subm-head">
                    <img src="../../assets/images/server2.png" alt="">
                    <span>大数据应用服务</span>
                  </div>
                </router-link>
                <div class="subm-msg">
                  <p>借助业界领先的数据、分析和安全运营解决方案，提供与目标数据模型精准匹配的数据源，通过机器学习、自动化和预测性分析提升数据应用价值。</p>
                </div>
                <div class="subm-con">
                  <div class="submc" v-for="(item, index) in subms[1].name" :key="index">
                    <router-link :to="{name: 'article', params: {
                      id: id2[index] + '.html',
                      ch: 33
                    }}">
                      <span>{{item}}</span>
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="subm">
                <router-link :to="{path: '/city.html'}">
                  <div class="subm-head">
                    <img src="../../assets/images/server3.png" alt="">
                    <span>智慧城市</span>
                  </div>
                </router-link>
                <div class="subm-msg">
                  <p>以城市治理与新一轮信息技术深度融合为代表的新型智慧城市建设，其核心是运用物联网、云计算、服务城市规划、建设、管理、服务等过程。</p>
                </div>
                <div class="subm-con">
                  <div class="submc" v-for="(item, index) in subms[2].name" :key="index">
                    <router-link :to="{name: 'article', params: {
                      id: id3[index] + '.html',
                      ch: 34
                    }}">
                      <span>{{item}}</span>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <div class="con-right2">
              <router-link :to="{ name: 'article', params: { id: 304 + '.html' , ch: 47}}">
                <div class="con-r">
                  <img src="../../assets/images/server4.png" alt=""><span>中天亿信亿信云平台</span>
                </div>
              </router-link>
              <router-link :to="{ name: 'article', params: { id: 305 + '.html' , ch: 47}}">
                <div class="con-r">
                  <img src="../../assets/images/server5.png" alt=""><span>中天亿信知识图谱平台</span>
                </div>
              </router-link>
              <router-link :to="{ name: 'article', params: { id: 306 + '.html' , ch: 47}}">
                <div class="con-r">
                  <img src="../../assets/images/server6.png" alt=""><span>中天亿信供应链管理系统</span>
                </div>
              </router-link>
              <router-link :to="{ name: 'article', params: { id: 307 + '.html' , ch: 47}}">
                <div class="con-r">
                  <img src="../../assets/images/server7.png" alt=""><span>中天亿信应急指挥调度平台</span>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div class="content1 content0" v-show="cont[2]">
          <div class="content-main">
            <div class="submain3">
              <div class="sm" v-for="(item, index) in sms">
                <router-link :to="{name: 'article', params: {
                  id: item.id + '.html',
                  ch: 31
                }}">
                  <img :src="item.src" alt="">
                  <div class="smr">
                    <h3>{{item.title}}</h3>
                    <p>{{item.description}}</p>
                  </div>
                </router-link>
              </div>
            </div>
            <!-- <div @click="showVideo" class="con-right">
              <div class="r-img">
                <img src="../../assets/images/video.png" alt="">
              </div>
              <div class="con-r-message">
                <p class="con-r-msg">以互联网+大数据为创新驱动，全力推进“互联网+”全面战略布局及生态链建设</p>
              </div>
            </div> -->
          </div>
          <div class="con-right2">
            <div class="conr2">
              <router-link :to="{ name: 'article', params: { id: 304 + '.html' , ch: 47}}">
                <div class="con-r">
                  <img src="../../assets/images/server4.png" alt=""><span>中天亿信亿信云平台</span>
                </div>
              </router-link>
              <router-link :to="{ name: 'article', params: { id: 305 + '.html' , ch: 47}}">
                <div class="con-r">
                  <img src="../../assets/images/server5.png" alt=""><span>中天亿信知识图谱平台</span>
                </div>
              </router-link>
              <router-link :to="{ name: 'article', params: { id: 306 + '.html' , ch: 47}}">
                <div class="con-r">
                  <img src="../../assets/images/server6.png" alt=""><span>中天亿信供应链管理系统</span>
                </div>
              </router-link>
              <router-link :to="{ name: 'article', params: { id: 307 + '.html' , ch: 47}}">
                <div class="con-r">
                  <img src="../../assets/images/server7.png" alt=""><span>中天亿信应急指挥调度平台</span>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </transition>
      <!-- <transition name="fade">
        <div class="content" v-if="cont[3]">
           <div class="con">
             <div class="con-choose">
                 <div class="con-a" :class="{'these': mainshow[index]}" @click="change(index)" v-for="(con, index) in mainl[3].son.filter(obj=>{return obj.parent_id != 0})" :key="index">
                   <h3>{{con.name}}</h3>
                   <p>{{con.msg}}</p>
                 </div>
             </div>
             <div class="main">
               <transition name="con">
                 <div class="con-main" v-if="mainshow[index]" v-for="(main, index) in mainl[3].son.filter(obj=>{return obj.parent_id != 0})" :key="index">
                   <div class="c-main main1">
                     <p href="" v-for="tip in main.list" @click="toNews(tip.id, tip.channel_id)">{{tip.title}}</p>
                   </div>
                 </div>
               </transition>
             </div>
             <div class="c-right" @click="toarticle4(mainl[3].son[1].list[0].id,mainl[4].son[1].list[0].channel_id)">
               <div class="r-img">
                 <img :src="'http://v2.ztys.com.cn' + mainl[3].son[1].list[0].image" alt="">
               </div>
               <div class="con-r-message">
                 <h1 class="con-r-t">{{mainl[3].son[1].list[0].title}}</h1>
                 <p class="con-r-msg">{{mainl[3].son[1].list[0].description}}</p>
                 <strong>查看详情</strong>
               </div>
             </div>
           </div>
        </div>
      </transition> -->
    </div>
  </header>
</template>

<script>
  import { api1 } from '../../api/index.js'
  import { option } from '../../public/public.js'
  import qs from 'qs'
  export default {
    data() {
      return {
        videoshow: false,
        slid1: false,
        slid2: false,
        slid3: false,
        slidershow: false,
        iphoneshow: false,
        qqshow: false,
        wxshow: false,
        show: false,
        cont: [false, false, false, false, false],
        num: 0,
        choose_show: false,
        mainshow: [true, false, false, false, false, false, false, false, false],
        subshow: [false, false, false, false, false],
        slideshow: [false, false, false, false, false],
        mainl: [],
        subms: [{
          title: "互联网定制开发",
          name: ["品牌网站建设", "站群建设", "商城系统", "微信小程序", "APP开发", "H5创意设计", "云主机", "行业应用开发", "数字营销"]
        }, {
          title: "大数据应用服务",
          name: ["数据资产管理", "挖掘分析", "可视化", "数字乡村", "智慧应急", "政务", "时空", "教育", "医疗", "电商", "文旅", "供应链", "用户画像"]
        }, {
          title: "智慧城市",
          name: ["城市大脑", "智能办公", "社会治理", "建筑智能化弱电系统", "安防工程", "智慧交通", "大数据中心建设"]
        }],
        id1: [194, 195, 287, 285, 286, 288, 197, 196, 198],
        id2: [292, 293, 294, 303, 289, 189, 186, 192, 187, 188, 191, 297, 301],
        id3: [299, 300, 296, 135, 134, 295, 136],
        sms: [
		{
          id: 203,
          src: require("../../assets/img/sys2.png"),
          title: "亿信云平台",
          description: "依托云原生与AI调度，融合云架构、边缘计算，打造未来智能算力平台。"
        },{
          id: 200,
          src: require("../../assets/img/sys3.png"),
          title: "知识图谱平台",
          description: "集数据分析、可视化展示、智能决策支持为一体的综合数据服务平台。"
        },{
          id: 201,
          src: require("../../assets/img/sys5.png"),
          title: "融合通信平台",
          description: "集成多种通信功能的管理平台，提升企业和组织的沟通效率与应急响应能力。"
        },{
		  id: 206,
          src: require("../../assets/img/sys8.png"),
          title: "应急指挥调度平台",
          description: "通过集成信息、资源和通信，提供高效决策支持，确保应急事件快速响应与处置。"         
        },{
		  id: 199,
          src: require("../../assets/img/sys1.png"),
          title: "政务大数据共享交换平台",
          description: "依托统一的“云”数据中心建设统一的公共数据开放共享平台"         
        },{
		  id: 204,
          src: require("../../assets/img/sys4.png"),
          title: "智慧校园管理系统",
          description: "全面的智能感知环境和综合信息服务平台"         
        },{
		  id: 205,
          src: require("../../assets/img/sys6.png"),
          title: "供应链管理系统",
          description: "借助实时供应链计划功能快速响应市场变化"
        },{
          id: 202,
          src: require("../../assets/img/sys7.png"),
          title: "网站（集群）内容管理系统",
          description: "提供内容丰富、形式多样、可扩展的内容管理云服务"
        }
		],
        main0: [{
          id: 110,
          ch: 37,
          title: '公司简介',
          description: '领先的互联网+大数据解决方案与服务提供商',
          img: require("../../assets/img/hicon1.png")
        }, {
          id: 116,
          ch: 40,
          title: '组织架构',
          description: '实现共同目标的高效扁平化组织',
          img: require("../../assets/img/hicon2.png")
        }, {
          id: 117,
          ch: 38,
          title: '领导致辞',
          description: '目标是心灵的远方，等待我们去靠近去征服',
          img: require("../../assets/img/hicon3.png")
        }, {
          id: 111,
          ch: 39,
          title: '企业文化',
          description: '为用户创造价值',
          img: require("../../assets/img/hicon4.png")
        }, {
          id: 118,
          ch: 42,
          title: '成长历程',
          description: '凡是过往，皆为序章。行而不辍，未来可期',
          img: require("../../assets/img/hicon5.png")
        }, {
          id: 118,
          ch: 42,
          title: '公司荣誉',
          description: '让每次胜利都无法忽视你的存在',
          img: require("../../assets/img/hicon6.png")
        }, {
          title: '招贤纳士',
          description: '集结高素质人才，我们不可战胜，无往而不利',
          img: require("../../assets/img/hicon7.png")
        }],
        src: [],
        src1: [],
        n: 0,
        headerColor: false
      }
    },
    methods: {
      navTo(index){
        if(index == 0){
          return {
            path: "/about.html"
          }
        }else if(index == 1){
          return {
            path: "/products.html"
          }
        }else if(index == 2){
          return {
            path: "/application.html"
          }
        }else if(index == 3){
          return {
            path: "/news.html"
          }
        }else if(index == 4){
          return {
            path: "/support.html"
          }
        }
      },
      tocon(id){
        this.$router.push({
          path: '/article',
          query: {
            ch: 31,
            id: id
          }
        })
      },
      slideTo(index){
        if(index <= 2){
          return{
            name: "article",
            params: {
              id: this.main0[index].id + '.html',
              ch: this.main0[index].ch,
            }
          }
        }else if(index == 3){
          return{
            name: "about",
            params: {
              id: 1
            }
          }
        }else if(index == 4){
          return{
            name: "about",
            params: {
              id: 2
            }
          }
        }else if(index == 5){
          return{
            name: "about",
            params: {
              id: 3
            }
          }
        }else if(index == 6){
          return{
            path: "/personnel.html"
          }
        }
      },
      showVideo() {
        this.videoshow = true
      },
      slide1() { //侧栏的显示
        this.slid1 = !this.slid1
        this.slid2 = false
        this.slid3 = false
        this.slid4 = false
      },
      slide2() {
        this.slid2 = !this.slid2
        this.slid1 = false
        this.slid3 = false
        this.slid4 = false
      },
      slide3() {
        this.slid3 = !this.slid3
        this.slid2 = false
        this.slid1 = false
        this.slid4 = false
      },
      topersonnel() {
        this.$router.push({
          path: '/personnel'
        })
      },
      to() {
        this.$router.push({
          path: '/'
        });
      },
      enter(index) {
        this.show = true
        setTimeout(() => {
          for (let i = 0; i <= 9; i++) {
            this.$set(this.cont, i, false)
          }
          this.$set(this.cont, index, true)
          this.num = index
        }, 500)
      },
      enterthis() {
        this.$set(this.cont, this.num, true)
      },
      leave() {
        setTimeout(() => {
          for (let i = 0; i <= 4; i++) {
            this.$set(this.cont, i, false)
          }
          this.show = false
        }, 500)
      },
      change(index) {
        for (let i = 0; i <= 9; i++) {
          this.$set(this.mainshow, i, false)
        }
        this.$set(this.mainshow, index, true)
      },
      subShow(index) {
        for (let i = 0; i <= 4; i++) {
          this.$set(this.subshow, i, false)
        }
        if (this.subshow[index] == false) {
          this.$set(this.subshow, index, true)
          this.n = 1
        } else if (this.subshow[index] == true) {
          this.$set(this.subshow, index, false)
          this.n = 0
        }
      },
      slideShow(index) {
        for (let i = 0; i <= 4; i++) {
          if (i == index) {
            continue
          }
          this.$set(this.slideshow, i, false)
        }
        this.$set(this.slideshow, index, !this.slideshow[index])
        console.log(this.slideshow[index])
      },
      handleScroll(){
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if(this.$route.path != "/"){
          if(scrollTop > 20){
            this.headerColor = true
          }else if(scrollTop < 20){
            this.headerColor = false
          }
        }
      }
    },
    mounted(){
      window.addEventListener('scroll', this.handleScroll)
    },
    created() {
      this.handleScroll;
      api1({
        apikey: 123456
      }).then(res => {
        console.log(res)
        // success
        this.mainl = res.data.nav
        this.mainl.splice(0, 1)

        for (let i = 0; i < (res.data.nav[0].son).length; i++) {
          for (let j = 0; j < (res.data.nav[0].son[i].list).length; j++) {
            //   this.main5.push(res.data.nav[0].son[i].list[j].description)
            this.src.push(res.data.nav[0].son[i].list[j].id)
          }
        }
        this.src.reverse()

      }).catch((error) => {
        // error
        console.log(error)

      })

    }
  }
</script>

<style scoped>
/* 头部样式 */

  /* 改变样式 */
  .headerColor{background-color: #fff; box-shadow: 0px -10px 50px 5px #000;}
  .headerColor nav .nav ul li p{color: #003E67 !important;}
  .headerColor .rkbox{background: #0052a5 !important; border-radius: 15px !important;}
  .headerColor .choose-box{background: #0052a5;}
  .headerColor .li-img{background: #0052a5;}
  .menu-control{height: 20px;}
  .headerColor .menu-control .menu-con,.headerColor .menu-control .menu-con::after,.headerColor .menu-control .menu-con::before{background: #004A7F}

  header{width: 100%; height: 71px; position: fixed; top: 0; z-index: 1001; transition: all .5s ease;}
  .header{width: 1410px; height: 71px; margin: 0 auto;}
  .header .logo{width: 133px; height: 71px; float: left; background: #00458e; cursor: pointer;}
  .header .logo img{position: relative; top: 50%; left: 50%; transform: translate(-50%, -50%);}

  .close{position: absolute; right: 10px; top: 10px; width: 30px; height: 30px; border-radius: 50%; color: #FFFFFF; z-index: 1200; cursor: pointer; border: 1px solid #fff; transition: all .5s;}
  .close::after{content: ""; display: block; width: 20px; height: 1px; background: #fff; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%) rotate(45deg);}
  .close::before{content: ""; display: block; width: 20px; height: 1px; background: #fff; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%) rotate(-45deg);}
  .close:hover{background-color: #fff;}
  .close:hover::before{background: #1b4591;}
  .close:hover::after{background: #1b4591;}
  .head-video{position: fixed; width: 100%; left: 0; top: 0; background: rgba(0, 0, 0, .6); height: 100%; z-index: 1000;}
  .videos{position:absolute; height: 70%;  left: 50%; top: 50%; transform: translate(-50%, -50%); border: 1px solid #fff; border-radius: 20px; overflow: hidden;}
  #videos{height: 100%;}
  /* 导航栏样式 */
  .header nav{display: inline-block;}
  .header nav .nav ul li{float: left; padding: 24px 0 0 20px;}
  .header nav .nav ul li p{text-decoration: none; cursor: pointer; font-size: 16px; color: #fff;}
  .header nav .nav ul li p::after{
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: .255em;
    vertical-align: .255em;
    content: "";
    border-top: .3em solid;
    border-right: .3em solid transparent;
    border-bottom: 0;
    border-left: .3em solid transparent;}
   .header nav .nav ul li p:hover{color: #88bf3d;}
   .header nav .nav ul li:last-child p::after{display: none;}
   .header nav .nav ul li:nth-child(4) p::after{display: none;}

  /* 中屏菜单icon样式 */
  .menu-control{float: right; padding: 30px 30px 0 0; display: none;}
  .menu-con{position: relative; width: 40px; height: 4px; background: #fff; transition: all .5s ease;}
  .menu-con::after{content: ""; position: absolute; display: block; width: 40px; height: 4px; background: #fff; left: 0; top: 14px; transition: all .5s ease;}
  .menu-con::before{content: ""; position: absolute; display: block; width: 40px; height: 4px; background: #fff; left: 0; top: -14px; transition: all .5s ease;}
  .menu-hover::after{transform: rotate(40deg); top: 0;}
  .menu-hover{background: rgba(0, 0, 0, 0) !important;}
  .menu-hover::before{transform: rotate(-40deg); top: 0;}


  .top-menu{position: absolute; top: 92px;}


  /* 头部右边信息样式 */
  .li-img{width: 30px; height: 30px; border-radius: 50%;}
  .header-right{float: right;}
  .header-right ul li{position: relative; display: inline-block; vertical-align: top; width: 31px; margin: 24px 0 0 14px;}
  .header-right ul li img{position: absolute; transition: all .5s ease; cursor: pointer;}
  .header-right ul li img:nth-child(1){opacity: 1;}
  .header-right ul li img:nth-child(2){opacity: 0;}
  .header-right ul li:hover img:nth-child(1){opacity: 0;}
  .header-right ul li:hover img:nth-child(2){opacity: 1;}
  .header-right ul li:nth-child(2) a{display: block; text-decoration: none; line-height: 30px; color: #fff;}
  .iphone{margin: 20px 0 0 -46px; left: 50%; display: inline-block; width: 120px; line-height: 40px; color: #fff; text-align: center; border: 1px solid #fff;}
  .qq{margin: 20px 0 0 -40px; white-space: nowrap; display: inline-block; padding: 10px; border: 1px solid #fff; color: #fff;}
  .qq p{display: block;}
  .wx{position: absolute; width: 100px; height: 100px; left: -36px; top: 40px;  border: 1px solid #fff; background: url(../../assets/images/erwei.png)  center center; background-size: 96% 96%;}
  .iphone, .qq, .wx{border-radius: 10px;}


  /* 登录信息选择样式 */
  .rkbox {position: relative; float: left; margin: 24px 10px 0 0;}
  .rkbox .had {width: 100px; height: 30px; background: url(../../assets/images/rkbg.png) no-repeat left center; padding-left: 40px; cursor: pointer; position: relative;}
  .rkbox .had span {width: 60px; display: block; height: 30px; font-size: 14px; line-height: 30px; color: #d6d6d6;}
  .rkbox .had .rkjt {position: absolute; right: 10px; top: 11px; -webkit-transition: all .4s; -o-transition: all .4s; -moz-transition: all .4s; transition: all .4s;}
  .rkbox .chosebox {background: rgba(255, 255, 255, 0.2); position: absolute; left: 0; width: 100%; top: 100%; padding: 10px 0; color: #fff; text-align: center;
      line-height: 30px; -webkit-border-radius: 15px; -moz-border-radius: 15px; border-radius: 15px; opacity: 0; pointer-events: none; -webkit-transition: all .4s;
      -o-transition: all .4s; -moz-transition: all .4s; transition: all .4s;}
  .choose-box a {display: block; color: #fff; text-align: center; line-height: 34px; font-size: 14px; text-decoration: none; cursor: pointer; outline: none; -moz-outline-style: none;}
  .choose-box a:hover{color: #88bf3d;}
  .choose-box{padding: 10px 0 10px 0; background: rgba(255, 255, 255, .1); border-radius: 20px;}

  /* 导航下拉菜单样式 */
  .content1{background: #fff; position: absolute; width: 100%;}
  .header-content{position: relative; width: 100%;}
  .header-content .content{position: absolute; top: 0; left: 0; z-index: 2; width: 100%; padding: 6% 0 4% 0; box-sizing: border-box; background: #fff;}
  .span{width: 100%;}
  .content .con{position: relative; width: 1410px; left: 50%; height: auto; transform: translateX(-50%); display: flex;}
  .con-choose{flex: 1;}
  .con-a{width: 90%; height: 70px; line-height: 70px; border-bottom: 1px solid #1b3fab; color: #003E67; padding: 0 20px 0 20px; box-sizing: border-box; background: #eff2fd;}
  .main{position: relative; flex: 2; height: auto; flex-shrink:0;}
  .con-main{position: absolute;}
  .c-right{flex: .8; margin-left: 30px; cursor: pointer; max-height: 320px; box-sizing: border-box; padding: 0 0 20px 0; word-wrap: break-word; overflow: hidden; background: #f1f1f1; border: 1px solid #fff; transition: .5s all ease;}
  .c-right .r-img{position: relative; width: 100%; padding-top: 60%; border: none !important;}
  .c-right img{position: absolute; top: 0; width: 100%; height: 100%; border: none}
  .c-right strong{position: relative; left: -72px; transition: all .5s ease;}
  .c-right:hover{ background: #fff; border: 1px solid #004A7F;}
  .c-right strong::after{content: ">"; font-family: '宋体'; padding-left: 10px;}
  .c-right:hover strong{left: 0;}

  .con-r-t{font-size: 16px; line-height: 24px; padding-top: 10px;}
  .con-right{flex: 1; margin-left: 30px; cursor: pointer; max-height: 360px; word-wrap: break-word; overflow: hidden; background: #fff; transition: .5s all ease;}
  .con-right .r-img{position: relative; width: 100%; padding-top: 60%; border: none !important;}
  .con-right img{position: absolute; top: 0; width: 100%; height: 100%; border: none}
  .con-right p{font-size: 14px; line-height: 24px; color: #333;}
  .con-right:hover{ background: #f1f1f1; }
  .con-right2{width: 22.6%; padding: 56px 0 60px 0; background: #2470c1;}
  .c-main p{display: inline-block; left: 0; position: relative; cursor: pointer; vertical-align: top; width: auto; font-size: 14px; color: #333333; width: 45%; font-weight: bold; padding: 5px 10px 5px 10px; transition: all .5s;}
  .c-main p:hover{left: 10px; color: #003E67;}
  .c-main h2{font-size: 16px; font-weight: bold; padding: 10px 10px 5px 10px;}
  .c-main{flex: 2;}
  .these{background: #fff !important;}
  .these h1{color: #0062A7;}
  .these h3::after{content: ">"; font-family: '宋体'; color: #0062A7; float: right;}
  .con-r-message{width: 90%; padding: 6px 0 6px 0; margin: auto; overflow: hidden; box-sizing: border-box; word-break: break-word}
  .con-r-message p{font-size: 12px; text-align: center; line-height: 28px; color: #9a9a9a;}
  .content-main{width: 1410px; margin: 0 auto; display: flex;}
  .submain{flex: 3.6; height: 300px; margin: 0 auto; display: flex; flex-wrap: wrap;}
  .submain1{width: 77.4%; display: flex; padding: 56px 6% 60px 0;  justify-content: space-between;}
  .submain3{height: 300px; padding: 56px 0 30px 0; margin: 0 auto; width: 100%; display: flex; flex-wrap: wrap;}
  .con-r{line-height: 56px; cursor: pointer; color: #fff; box-sizing: border-box; padding-left: 20px;}
  .con-r *{display: inline-block; vertical-align: middle;}
  .con-r span{padding-left: 10px;}
  .con-r:hover{background: #004A7F;}
  .conr2{display: flex; width: 1440px; margin: 0 auto;}
  .conr2 a{flex: 1;}

  .href{width: 33%; padding: 5px 40px 5px 5px; box-sizing: border-box; cursor: pointer; transition: all .5s ease;}
  .href img{width: 21px;}
  /* .href h3::after{content: ">"; position: absolute; line-height: 34px; opacity: 0; font-family: '宋体'; font-size: 16px; right: 100px; transition: all .8s ease-in-out;} */
  .href h3:hover span{left: 20px;}
/*  .href :hover::after{opacity: 1; right: 10px;} */
  .href h3:hover img{left: 0;}
  .href h3{padding-left: 10px; color: #333; position: relative; display: block; transition: all .8s ease-in-out; height: 34px}
  .href h3 span{position: relative; left: 0; font-size: 16px; padding-left: 10px; line-height: 32px; transition: all .8s ease-in-out;}
  .href h3 *{position: relative; left: 0; display: inline-block; vertical-align: middle; transition: all .8s ease-in-out;}
  .href p{font-size: 14px; padding-left: 10px; line-height: 26px; color: #7f7e7e;}

  .subm-head{height: 34px; cursor: pointer;}
  .subm-head img{width: 28px;}
  .subm-head *{display: inline-block; vertical-align: middle;}
  .subm-head span{padding-left: 10px; font-weight: bold; color: #505050; left: 0; position: relative; transition: all .5s;}
  .subm-head:hover span{left: 20px;}
  .subm-msg{font-size: 14px; color: #7f7f7f; line-height: 24px; padding: 10px 0 10px 0;}
  .subm{width: 292px;}
  .subm:nth-child(1){width: 270px;}
  .subm:nth-child(2){width: 310px; }
  .subm:nth-child(3){width: 300px;}
  .subm-con{width: 100%; display: flex; flex-wrap: wrap; justify-content: space-between;}
  .submc span{position: relative; display: block; width: 100%; height: 100%; color: #515a6e; z-index: 5; transition: all .5s ease;}
  .submc{margin-top: 5px; position: relative; text-align: center; cursor: pointer; border: 1px solid #9c9c9c; box-sizing: border-box; line-height: 26px; font-size: 14px; color: #515a6e}
  .submc::before{content: ""; position: absolute; left: 0; top: 0; width: 0; height: 100%; background: #0062A7; transition: all .5s ease; z-index: 0;}
  .submc:hover::before{width: 100%;}
  .submc:hover span{color: #fff;}
  /* 细节调整 */
  /* 1 */
  .subm:nth-child(1) .submc:nth-child(1),.subm:nth-child(1) .submc:nth-child(2),.subm:nth-child(1) .submc:nth-child(3),
  .subm:nth-child(1) .submc:nth-child(4),.subm:nth-child(1) .submc:nth-child(5),.subm:nth-child(1) .submc:nth-child(6){width: 32%;}
  .subm:nth-child(1) .submc:nth-child(7){width: 26%;}
  .subm:nth-child(1) .submc:nth-child(8),.subm:nth-child(1) .submc:nth-child(9){width: 35%;}
  /* 2 */
  .subm:nth-child(2) .submc:nth-child(1){width: 40%;}
  .subm:nth-child(2) .submc:nth-child(2),.subm:nth-child(2) .submc:nth-child(3){width: 28%;}
  .subm:nth-child(2) .submc:nth-child(4),.subm:nth-child(2) .submc:nth-child(5),.subm:nth-child(2) .submc:nth-child(n+12):nth-child(-n+13){width: 23%;}
  .subm:nth-child(2) .submc:nth-child(n+6):nth-child(-n+11){width: 16%;}
  /* 3 */
  .subm:nth-child(3) .submc:nth-child(n+1):nth-child(-n+3){width: 32%;}
  .subm:nth-child(3) .submc:nth-child(4),.subm:nth-child(3) .submc:nth-child(7){width: 66%;}
  .subm:nth-child(3) .submc:nth-child(5),.subm:nth-child(3) .submc:nth-child(6){width: 32%;}


   /* 三三三三三三三三 */
  .sm{display: inline-block; width: 50%; cursor: pointer;}
  .sm *{transition: all .5s ease;}
  .sm:hover h3{left: 20px;}
  .sm img{display: inline-block; position: relative; left: 0; vertical-align: top; padding-top: 6px;}
  .sm .smr{display: inline-block; padding-left: 10px;}
  .smr h3{position: relative; left: 0; font-weight: normal; font-size: 16px; color: #212121; line-height: 24px;}
  .smr p{position: relative; left: 0; font-size: 14px; color: #a6a6a6; line-height: 24px;}

  .personnel{position: relative; left: 0; top: 0; display: inline-block; font-size: 20px; padding: 12px; cursor: pointer; transition: all .8s ease-in-out;}
  .personnel:hover{left: 2px; top: -2px; text-shadow: -2px 0 4px #000000; color: #ffffff;}
  .hall{width: 90%; max-width: 1410px; margin: 0 auto;}


  /* 侧栏样式 */
  .slide-menu{position: fixed; z-index: 1000; top: 0; left: -100%; height: 100%; color: #fff; width: 100%; transition: all .5s ease;}
  .slide-menu span, .slide-menu h3{color: #fff;}
  .slide-main{width: 70%; height: 100%; position: relative; left: 0; overflow-y: scroll; background: #0A173E; padding: 40px; box-sizing: border-box;}
  .slide-main h3{cursor: pointer;}
  .slide-main h3 .plus{display: block; position: relative; top: -2px; width: 30px; float: right; text-align: center;  border: 1px solid rgba(255, 255, 255, .2); line-height: 24px;}
  .sub-slide{padding: 20px 0 0 0;}
  .sub-slide:nth-child(2){padding: 20px 0 0 0;}
  .sub-slide ul{padding-left: 10px;}
  .sub-slide .a2{padding-left: 10px;}
  .sub-slide li{padding: 10px 0 10px 0;}
  .sub-slide li:nth-child(1){padding: 20px 0 10px 0;}
  .slide-main::-webkit-scrollbar{width: 2px;}
  .slide-span{position: absolute; width: 100%; height: 100%; z-index: -1; background: #000; opacity: .6;}

  .slide-show{left: 0;}

  /* 动画定义 */
  .fade-enter-active { transition: all .5s ease;}
  .fade-leave-active { transition: all .5s ease;}
  .fade-enter, .fade-leave-to{ transform: translateX(-1000px); opacity: 0;}

  .ul_main-enter-active { transition: all 2s ease;}
  .ul_main-leave-active { transition: all 2s ease;}
  .ul_main-enter, .ul_main-leave-to{ left: -500px;}

  .slide_menu-enter-active { transition: all 1s ease-in-out;}
  .slide_menu-leave-active { transition: all .3s ease;}
  .slide_menu-enter, .slide_menu-leave-to{  opacity: 0;}

  .con-enter-active { transition: all .5s ease;}
  .con-leave-active { transition: all .5s ease;}
  .con-enter{ transform: translateY(300px); opacity: 0;}
  .con-leave-to{opacity: 0;}

  @keyframes videos{
    0%{
      transform: rotate(0deg) scale(0);
    }
    50%{
      transform: rotate(10deg) scale(0.7);
    }
    100%{
      transform: rotate(0deg) scale(1);
    }
  }

  @keyframes videoss{
    0%{
      transform: rotate(0deg) scale(1);
    }
    50%{
      transform: rotate(10deg) scale(0.7);
    }
    100%{
      transform: rotate(0deg) scale(0);
    }
  }

  .vides-enter-active { animation: videos 1s; }
  .vides-leave-active { animation: videoss 1s;}
  /* .vides-enter, .vides-leave-to{  transform: scale(0); background: none;} */

  @media screen and (min-width: 1560px) {
     .main1{padding-left: 20px;}
  }
  @media screen and (max-width: 1410px) {
    .header{width: 100%}
    .content-main{width: 100%;}
    .conr2{width: 100% !important; box-sizing: border-box; padding: 0 123px 0 123px;}
    .con{width: 96% !important;}
    .content .con{width: 100%}
    .c-main p{width: 100%}
    .main{flex: 1;}
    .header-right{padding-right: 20px;}
    .submain3{padding: 56px 133px 30px 133px;}
  }
  @media screen and (max-width: 1500px) {
    .wx{left: -50px;}
  }
  @media screen and (min-width: 1281px) and (max-width: 1440px)  {
    .submain1{padding-right: 60px; width: 77%;}
    .content-main{width: 96%;}
    .con{width: 90% !important;}
    .subm{width: 240px;}
    .submc{font-size: 12px;}
    .subm-msg{font-size: 12px;}
    .con-right2{width: 23%;}
    .con-r{padding-left: 20px; font-size: 14px;}
    .smr h3{font-size: 15px;}
    .smr p{font-size: 13px;}
  }
  @media screen and (min-width: 1024px) and (max-width: 1280px) {
    .content-main{flex-wrap: wrap;}
    .content{box-sizing: border-box; padding-left: 133px !important; padding-right: 133px !important;}
    .submain1{padding-right: 0; padding: 56px 0 40px 0; width: 1000px; margin: 0 auto;}
    .subm{width: 240px;}
    .subm-head span{font-size: 16px; font-weight: bold;}
    .submc{font-size: 12px;}
    .subm-msg{font-size: 12px;}
    .con-right{max-height: 230px;}
    .con-right2{width: 100%; padding: 0; text-align: center;}
    .con-right2 div{display: inline-block; vertical-align: top;}
    .con-r{padding: 0; font-size: 14px; width: 250px; text-align: center;}
    .con-r span{padding: 0;}
    .con-r img{padding-right: 10px;}
    .smr h3{font-size: 15px;}
    .smr p{font-size: 13px;}
/*    .sm img{display: none;} */
/*    .smr{padding-right: 20px;} */
    .sm{line-height: 40px; padding: 7px 0 7px 0;}
    .wx{right: 0;}
  }
  @media screen and (min-width: 1281px) {
    .content0 .con-right2{width: 100%; text-align: center; padding: 0;}
    .content0 .con-right2 .conr2{width: 1410px; margin: 0 auto; display: flex;}
    .content0 .con-right2 div{flex: 1;}
  }
  @media screen and (max-width: 1279px) {
    .href{padding-right: 30px}
    .href{width: 50%;}
    .submain{height: auto;}
    .c-main{display: block;}
    .submain{flex: 3;}
    .conr2 .con-r img{display: none;}
    .conr2 .con-r{flex: 1; width: 24%}
  }
/*  @media screen and (max-width: 1200px) {
    .header-right ul li:nth-child(-n+4){display: none;}

    .c-main{display: block;}
  } */
  @media screen and (max-width: 1024px) {
    .header nav{display: none;}
    .header-right{display: none;}
    .menu-control{display: block;}

  }
  @media screen and (max-width: 1560px) {
    .con-right{margin-left: 0;}

  }
  @media screen and (max-width: 786px) {
    .sub-slide li{font-size: 12px;}
    .slide-main h3{font-size: 16px;}
    header{height: 61px;}
    .header{height: 61px;}
    .logo{height: 61px !important;}
  }

</style>



// WEBPACK FOOTER //
// src/components/public/header.vue